import { IMAGE_DATA_SANITIZED, SanitizeStateForStorage } from './processor';

export const actionSanitizer = (action: any) => {
    if (
        (action.type === 'SAVE_CHECKLIST_PROGRESS' || action.type === 'STORE_OFFLINE_PROTOCOL_PHOTOS') &&
        action.payload
    ) {
        const { checkupPhotos, damagePhotos } = action.payload;
        const payload = {
            ...action.payload,
            checkupPhotos: checkupPhotos.map((photo) => ({ ...photo, data: IMAGE_DATA_SANITIZED })),
            damagePhotos: damagePhotos.map((photo) => ({ ...photo, data: IMAGE_DATA_SANITIZED })),
        };
        return { ...action, payload };
    } else {
        return action;
    }
};

export const stateSanitizer = (state: any) => {
    return {
        ...state,
        overview: SanitizeStateForStorage(state.overview)
    };
};
